const MutationObserver = window.MutationObserver
  || window.WebKitMutationObserver
  || window.MozMutationObserver

/**
 * Создает новый MutationObserver.
 * @param {Node} node Отслеживаемый узел.
 * @param {Object} config Конфигурация.
 * @param {Function} callback Сработает при изменении узла.
 * @returns {MutationObserver} Новый MutationObserver.
 */
export default function createMutationObserver (node, config, callback) {
  const mutationObserver = new MutationObserver(callback)
  mutationObserver.observe(node, config)
  return mutationObserver
}
